export const stinaPrivacyPolicyUrl = 'https://www.spotemotion.com/privacy-policy/';
export const stinaImprintUrl = 'https://www.spotemotion.com/imprint/';
export const stinaTermsAndConditionsUrl = 'https://www.spotemotion.com/terms-and-conditions/';

export const deutschePostTermsAndConditions = 'https://www.deutschepost.de/dialogmarketing/downloads/agb';